const getPatientDob = ({ patient, value, slice }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return slice ? patient['Date of Birth'].replace(/[/]/g, '').substring(slice[0], slice[1]) : patient['Date of Birth'].replace(/[/]/g, '');
};

export default getPatientDob;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientDob.js